async function apiFetch(url, options = {}) {
  try {
    const stripPrefix = process.env.VUE_APP_STRIP_API_PREFIX
    const resolvedUrl = stripPrefix ? url.replace(stripPrefix, '') : url
    // Perform the fetch request
    const response = await fetch(resolvedUrl, options)

    // Check if response status is 401 (Unauthorized)
    if (response.status === 401) {
      // Redirect to the login page
      localStorage.clear()
      this.$router.push('/auth/sign-in') // Ensure your route name is 'login'
    }

    // Parse and return the response as JSON if no error

    return response
  } catch (error) {
    console.error('Fetch error:', error)
  }
}
export default {
  install(app) {
    app.config.globalProperties.$apiFetch = apiFetch
  },
}
